import { useContext } from 'react'
import { CanvasScaleContext } from './canvasScaleContextCore'

export const useCanvasScale = () => {
  const context = useContext(CanvasScaleContext)

  if (!context) {
    throw new Error('useCanvasScale must be used inside CanvasScaleProvider')
  }

  return context
}
